import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { apmCaptureError } from '../../apm'
import { type LOCALE } from '../../i18n'

import { gkAirAccessorGetUnderscoreLocale } from './gkAirAccessorGetUnderscoreLocale'

export const gkAirAccessorGetLocalizedProductUrl = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string => {
  const productUrl = product[`url_${gkAirAccessorGetUnderscoreLocale(locale)}`]

  if (!productUrl) {
    apmCaptureError(
      new Error(
        `GK_AIR: product url not found for "${product.UID}" for ${locale}`,
      ),
    )

    return ''
  }

  return productUrl
}
